/* src/app/components/case/uploads/dat-metadata-mapping/last-run-review-dialog/last-run-review-dialog.component.scss */
mat-dialog-content {
  margin: 24px;
  min-width: 375px;
  min-height: 100px;
  display: flex;
  flex-direction: column;
}
pre {
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
  max-height: 600px;
  overflow-y: auto;
}
/*# sourceMappingURL=last-run-review-dialog.component.css.map */
